"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.confirmProps = exports.defaultConfig = exports.prefixCls = void 0;
var prefixCls = 'Modal';
exports.prefixCls = prefixCls;
var defaultConfig = {
  width: 380
};
exports.defaultConfig = defaultConfig;
var confirmProps = {
  okButtonProps: {
    className: 'button button-primary'
  },
  cancelButtonProps: {
    className: 'button button-secondary'
  }
};
exports.confirmProps = confirmProps;